import React, { useState } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import QRCode from "qrcode.react";
import Modal from "./Modal";

export default function QrModal({ donate, color }) {
  const [centredModal, setCentredModal] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [qrTitle, setQrTitle] = useState("Copy donation address");

  const toggleShow = () => setCentredModal(!centredModal);

  const toggleToast = () => setToggle(!toggle);

  const copyText = (text) => {
    /* Copy text into clipboard */
    navigator.clipboard.writeText(text);
    setQrTitle("Copied to clipboard");
    toggleToast();
  };

  return (
    <>
      <Modal
        getProgress={toggle}
        style={color}
        receiptModal={`${qrTitle}: ${donate.slice(0, 5)}...${donate.slice(-5)}`}
        explorer={null}
        hash={null}
        time={5}
      ></Modal>
      <a onClick={toggleShow}>
        ☕{" "}
        <span
          title="Donate to the developer"
          className={`text-${color} pointer link`}
        >
          Buy me a coffee
        </span>
      </a>

      <MDBModal tabIndex="-1" show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog centered size="sm">
          <MDBModalContent className={"bg-dark"}>
            <MDBModalHeader>
              <MDBModalTitle className={`text-${color}`}>
                🤓 Donate to dev
              </MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color={color}
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <span
                className="copy"
                title={qrTitle}
                onClick={() => copyText(donate)}
              >
                {" "}
                <QRCode value={donate} />
              </span>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
